import React from "react";
import { Row, Col } from "react-bootstrap";

const KnoaCardMainRow = ({ icon, subHeading, heading, mainRowHeight }) => {
    const subHeadingStyle = {
        color: subHeading.color,
        flex: 1,
    };

    const headingStyle = {
        color: heading.color,
        fontSize: "22px",
        flex: 1,
    };

    const iconClass = `${icon.name} ${
        icon.status === "success"
            ? "text-success"
            : icon.status === "danger"
                ? "text-danger"
                : "selectCardIcon"
    }`;

    return (
        <Row
            className="align-items-start"
            style={{ minHeight: mainRowHeight || "auto" }}
        >
            <Col xs="auto" className="d-flex align-items-start ps-0">
                <i className={`bigIcon ${iconClass}`} />
            </Col>
            <Col className="d-flex flex-column align-items-end text-end">
                <div id={subHeading.id} style={subHeadingStyle}>
                    {subHeading.text}
                </div>
                <h5 id={heading.id} style={headingStyle} className="mb-0">{heading.text}</h5>
            </Col>
        </Row>
    );
};

export default KnoaCardMainRow;